import React from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { READ_ARTICLE } from '../data/navbar/menu';

const MediaCard = (props) => {
  const {t} = useTranslation();
  return(
    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 card-div" >
      <Card style={{ height:"100%", width:'100%'}}>
        <Card.Img variant="top" class='article-image' src={props.image}/>
        <Card.Body>
          <Card.Title>{props.title}</Card.Title>
          {/* <Card.Text> {props.headline} </Card.Text> */}
        </Card.Body>
        <Card.Footer>
          <div class="media-info">
          <Card.Img variant="top" class='media-logo' src={props.medialogo}/>
            <Card.Text> <b>{props.medianame}</b> </Card.Text>
            </div>
          <Card.Link style={{ backgroundColor: 'white' }} href={props.link} target="_blank" rel="noopener noreferrer" >{t(READ_ARTICLE)}</Card.Link>
        </Card.Footer>
      </Card>
    </div>
  );
}

export default MediaCard;
